const inquiriesActionTypes = {
    SET_INQUIRIES:'SET_INQUIRES',
    ADD_INQUIRY:'ADD_INQUIRY',
    DEL_INQUIRY:'DEL_INQUIRY',
    DEL_MUL_INQUIRIES:'DEL_MUL_INQUIRIES'
}

export default inquiriesActionTypes